import { render } from "./nav-product-stepper-button.vue?vue&type=template&id=87f8b7fe"
import script from "./nav-product-stepper-button.vue?vue&type=script&lang=js"
export * from "./nav-product-stepper-button.vue?vue&type=script&lang=js"
script.render = render

export default script